export default __webpack_public_path__ + "static/media/A10.f2efa420.png";